const ExpandView = ({onClick}) => {
  return (
    <div className="text=[#616161] text-sm cursor-pointer" onClick={onClick}>Expand view</div>
  );
};

export default ExpandView;
